webpackJsonp([32],{

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mastodon_emoji__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mastodon_locales__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stringz__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stringz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stringz__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intl_relativeformat__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rails_ujs__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rails_ujs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rails_ujs__);






__webpack_require__(170);

var _getLocale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mastodon_locales__["b" /* getLocale */])(),
    localeData = _getLocale.localeData;

localeData.forEach(__WEBPACK_IMPORTED_MODULE_3_intl_relativeformat___default.a.__addLocaleData);

function main() {
  var locale = document.documentElement.lang;
  var dateTimeFormat = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  });
  var relativeFormat = new __WEBPACK_IMPORTED_MODULE_3_intl_relativeformat___default.a(locale);

  document.addEventListener('DOMContentLoaded', function () {
    [].forEach.call(document.querySelectorAll('.emojify'), function (content) {
      content.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mastodon_emoji__["a" /* default */])(content.innerHTML);
    });

    [].forEach.call(document.querySelectorAll('time.formatted'), function (content) {
      var datetime = new Date(content.getAttribute('datetime'));
      var formattedDate = dateTimeFormat.format(datetime);
      content.title = formattedDate;
      content.textContent = formattedDate;
    });

    [].forEach.call(document.querySelectorAll('time.time-ago'), function (content) {
      var datetime = new Date(content.getAttribute('datetime'));
      content.textContent = relativeFormat.format(datetime);;
    });
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rails_ujs__["delegate"])(document, '.video-player video', 'click', function (_ref) {
    var target = _ref.target;

    if (target.paused) {
      target.play();
    } else {
      target.pause();
    }
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rails_ujs__["delegate"])(document, '.media-spoiler', 'click', function (_ref2) {
    var target = _ref2.target;

    target.style.display = 'none';
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rails_ujs__["delegate"])(document, '.webapp-btn', 'click', function (_ref3) {
    var target = _ref3.target,
        button = _ref3.button;

    if (button !== 0) {
      return true;
    }
    window.location.href = target.href;
    return false;
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rails_ujs__["delegate"])(document, '.status__content__spoiler-link', 'click', function (_ref4) {
    var target = _ref4.target;

    var contentEl = target.parentNode.parentNode.querySelector('.e-content');
    if (contentEl.style.display === 'block') {
      contentEl.style.display = 'none';
      target.parentNode.style.marginBottom = 0;
    } else {
      contentEl.style.display = 'block';
      target.parentNode.style.marginBottom = null;
    }
    return false;
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rails_ujs__["delegate"])(document, '.account_display_name', 'input', function (_ref5) {
    var target = _ref5.target;

    var nameCounter = document.querySelector('.name-counter');
    if (nameCounter) {
      nameCounter.textContent = 30 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_stringz__["length"])(target.value);
    }
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rails_ujs__["delegate"])(document, '.account_note', 'input', function (_ref6) {
    var target = _ref6.target;

    var noteCounter = document.querySelector('.note-counter');
    if (noteCounter) {
      noteCounter.textContent = 160 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_stringz__["length"])(target.value);
    }
  });
}

if (!window.Intl) {
  __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 171)).then(function () {
    main();
  }).catch(function (error) {
    console.log(error); // eslint-disable-line no-console
  });
} else {
  main();
}

/***/ })

},[466]);


// WEBPACK FOOTER //
// public-9a4f50b7d22990a6ee3a.js